import { FormattedMessage } from 'react-intl';

import { DismissableBanner } from '../../../common/banner/DismissableBanner';

export const MaintenanceInfoBanner = () => {
    const shouldShowBanner = false;
    return (
        <DismissableBanner
            storageKey='maintenance-products-info-dismissed'
            shouldShow={shouldShowBanner}
            icon={<span className='uikit-icon icon-info-sign text-size-200pct' />}
            title={<FormattedMessage id='marketplace.customercenter.maintenance.banner.title' />}
            className='margin-bottom-15'
        >
            <p className='margin-bottom-5'>
                <FormattedMessage id='marketplace.customercenter.maintenance.banner.text' />
            </p>
        </DismissableBanner>
    );
};
